import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import ClientPopUp from "./client_popup.js";
import MultiSelectNew from "./multiSelect.js";
import AddClient from "./addClient_popup.js";
import { MultiSelect } from "react-multi-select-component";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const AcceptClients = (props) => {
  const [clients, setClients] = useState([]);
  const [clientsReportValue, setClientsReportValue] = useState([]);
  const [showClientReport, setShowClientReport] = useState(false);
  const [showAddClient, setShowAddClient] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsToAccept", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClients(getAllowedClients(data));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const getData = () => {
    setLoading(true);
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setClientsReportValue(value);
    handleShowClientReport();
  };

  const handleShowClientReport = () => {
    setShowClientReport(true);
  };

  const closeClientReport = () => {
    setShowClientReport(false);
    getData();
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = props.clientsSygnData.filter((el) => el.client_id === clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0 ? sygns[0].sygn : "brak danych";
  };

  const clientsData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Powód</th>
          <th>Prawnik</th>
          <th>Status sprawy</th>
          <th>Aktualna sygnatura sprawy</th>
          <th>Sąd</th>
          <th>Bank</th>
          <th>Rodzaj sprawy</th>
        </tr>
        {clients
          .filter((el) => el.accepted === "no")
          .map((el) => (
            <>
              <tr id={""} key={el.id}>
                <td
                  style={{
                    fontWeight: "600",
                    maxWidth: "15%",
                    wordBreak: "break-word",
                  }}
                  value={el.id}
                  onClick={handleRowClick}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      gap: "10px",
                      position: "relative",
                    }}
                  >
                    <div style={{ paddingRight: "30px", paddingLeft: "5px" }}>
                      {el.petitioner}
                    </div>
                  </div>
                </td>
                <td value={el.id} onClick={handleRowClick}>
                  {el.client_owner}
                </td>
                <td value={el.id} onClick={handleRowClick}>
                  {el.status}
                </td>
                <td value={el.id} onClick={handleRowClick}>
                  {el.aSygn}
                </td>
                <td value={el.id} onClick={handleRowClick}>
                  {el.aCourt}
                </td>
                <td value={el.id} onClick={handleRowClick}>
                  {el.bank}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    width: "15%",
                    padding: "10px",
                  }}
                  value={el.identifier}
                  onClick={handleRowClick}
                >
                  {el.type}
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  const clientsDataMobile = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Powód</th>
          <th>Prawnik</th>
          <th>Rodzaj sprawy</th>
        </tr>
        {clients
          .filter((el) => el.accepted === "no")
          .map((el) => (
            <>
              <tr id={""} key={el.id}>
                <td
                  style={{
                    fontWeight: "600",
                    wordBreak: "break-word",
                    width: "50%",
                  }}
                  value={el.id}
                  onClick={handleRowClick}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      gap: "10px",
                      position: "relative",
                    }}
                  >
                    <div style={{ paddingRight: "30px", paddingLeft: "5px" }}>
                      {el.petitioner}
                    </div>
                  </div>
                </td>
                <td
                  style={{ width: "10%" }}
                  value={el.id}
                  onClick={handleRowClick}
                >
                  {el.client_owner}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    width: "40%",
                    padding: "10px",
                  }}
                  value={el.identifier}
                  onClick={handleRowClick}
                >
                  {el.type}
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <div id="reportC" className="mainContainerClients">
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {showClientReport ? (
            <ClientPopUp
              close={closeClientReport}
              paymentsData={props.paymentsData}
              paymentsSheetData={props.paymentsSheetData}
              transactionsSheetData={props.transactionsSheetData}
              transactionsASheetData={props.transactionsNaSheetData}
              transactionsData={props.transactionsData}
              paymentsArchiveSheetData={props.paymentsArchiveSheetData}
              id={clientsReportValue}
              refreshData={props.refreshData}
              user={props.user.name}
              clientsData={
                clients.filter((el) => +el.id === +clientsReportValue)[0]
              }
              clientsSheetData={props.clientsSheetData}
              userRole={props.user.role}
              tasksData={props.tasksData}
              hearingsData={props.hearingsData}
              hearingsSheetData={props.hearingsSheetData}
              tasksSheetData={props.tasksSheetData}
              lawyersData={props.lawyersData}
              courtsData={props.courtsData}
              banksData={props.banksData}
              users={props.usersData}
              resultsData={props.resultsData}
              tasksTypesData={props.tasksTypesData}
              checkPermissions={props.checkPermissions}
              hearingsTeam2Data={props.hearingsTeam2Data}
              hearingsTeam2SheetData={props.hearingsTeam2SheetData}
              tasksTeam2Data={props.tasksTeam2Data}
              tasksTeam2SheetData={props.tasksTeam2SheetData}
              archTasksTeam2={props.archTasksTeam2}
              archDateTeam2={props.archDateTeam2}
              archDate={props.archDate}
              clientsSygnData={props.clientsSygnData}
              clientsSygnSheetData={props.clientsSygnSheetData}
              actualSygn={getActualSygnForClient(clientsReportValue)}
              clientsContactData={props.clientsContactData}
              clientsContactSheetData={props.clientsContactSheetData}
              logClientAction={props.logClientAction}
              clientsLogsData={props.clientsLogsData}
              clientsQuestData={props.clientsQuestData}
              clientsQuestSheetData={props.clientsQuestSheetData}
              tabIndex={0}
              team={props.team}
              place={"list"}
              uData={props.user}
            />
          ) : !showClientReport ? (
            <>
              <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
                SPRAWY DO AKCEPTACJI (
                {clients.filter((el) => el.accepted === "no").length} rekordów)
              </p>
              <span className="noteModuleP">
                kliknij w rekord, aby zobaczyć szczegóły
              </span>
              <div className="desktopFilters">
                <div className="contentBoxPayments">{clientsData}</div>
              </div>
              <div className="mobileFilters">
                <div className="contentBoxPayments">{clientsDataMobile}</div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default AcceptClients;
